import {Component, Injector, OnInit} from '@angular/core';
import {PomodoroRepository} from '../../Models/PomodoroRepository';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-tour',
  templateUrl: './tour.component.html',
  styleUrls: ['./tour.component.css']
})
export class TourComponent implements OnInit {
  public pomodoroRepository: PomodoroRepository;
  constructor(public dialog: MatDialog,
              public injector: Injector) {
    this.pomodoroRepository = PomodoroRepository.getInstance(injector);
  }
  ngOnInit(): void {
  }
  askToStartTour(): any{
    this.pomodoroRepository.startTour = true;
    localStorage.setItem('tourMode', String(this.pomodoroRepository.startTour));
    this.pomodoroRepository.ctlOne = true;
    this.dialog.closeAll();
  }
}
